// assets
import React, { useEffect, useState, useRef} from "react";
import {useSelector,useDispatch} from "react-redux";
import axios from "axios";
import { Badge } from "@material-ui/core";
import configData from "../config";
import {useTheme } from "@material-ui/styles";
import { setNotificationCount } from "../store/notificationReducer";
import alertSound from "../views/dashboard/air/img/tone.mp3";

import {
    IconDashboard,
    IconDeviceAnalytics,
    IconActivity,
    IconMailbox,
    IconBellPlus,
    IconFilter,
    IconReport,
    IconUser,
    IconTemperaturePlus,
    IconBatteryAutomotive,
    IconRouter,
    IconDevices,
    IconDetails,
    IconGitCompare,
    IconCalculator,
    IconRoute,
    IconKey,
    IconHelp,
    IconRecharging,
    IconSettingsAutomation,
    IconPlug,
    IconLink,
    IconUsers,
    IconPower,
    IconFileReport,
    IconBellRinging,
    IconLineDashed,
    IconReceipt,
    IconDeviceDesktopAnalytics
} from "@tabler/icons";

import {IconSparkles} from '@tabler/icons-react';
// constant

const icons = {
    IconActivity: IconActivity,
    IconDashboard: IconDashboard,
    IconMailbox: IconMailbox,
    IconBellPlus: IconBellPlus,
    IconFilter:IconFilter,
    IconReport: IconReport,
    IconDeviceAnalytics: IconDeviceAnalytics,
    IconUser: IconUser,
    IconTemperaturePlus: IconTemperaturePlus,
    IconBatteryAutomotive: IconBatteryAutomotive,
    IconRouter: IconRouter,
    IconSettingsAutomation: IconSettingsAutomation,
    IconDevices: IconDevices,
    IconDetails: IconDetails,
    IconGitCompare: IconGitCompare,
    IconCalculator: IconCalculator,
    IconRoute: IconRoute,
    IconKey: IconKey,
    IconHelp: IconHelp,
    IconPlug: IconPlug,
    IconPower:IconPower,
    IconRecharging: IconRecharging,
    IconLink: IconLink,
    IconUsers: IconUsers,
    IconFileReport:IconFileReport,
    IconBellRinging:IconBellRinging,
    IconLineDashed:IconLineDashed,
    IconReceipt:IconReceipt,
    IconDeviceDesktopAnalytics: IconDeviceDesktopAnalytics,
    IconSparkles:<IconSparkles color={"#5A2299"}/>
};


// -----------------------|| SINGLETON POLLING LOGIC ||-----------------------//
let pollingStarted = false;
let intervalId = null;

const startNotificationPolling = async (dispatch, token) => {
  if (!token || pollingStarted) return;
  pollingStarted = true;

  const fetchNotificationCount = async () => {
    try {
      const response = await axios.get(
        `${configData.API_SERVER}user/notification_badge`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      dispatch(setNotificationCount(response.data?.fire_all_system_count || 0));
    } catch (error) {
      console.error("Notification fetch failed:", error);
    }
  };

  await fetchNotificationCount();
  intervalId = setInterval(fetchNotificationCount, 60000);
};

export const stopNotificationPolling = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
    pollingStarted = false;
  }
};

// -----------------------|| HOOK TO USE IN ANY DASHBOARD ||-----------------------//
export const useStartNotificationPolling = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.account.token);

  useEffect(() => {
    if (token) startNotificationPolling(dispatch, token);

    return () => {
      stopNotificationPolling();
    };
  }, [dispatch, token]);
};

//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//
export const useEmsDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();
    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/ems/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/ems/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account?.user_role === 6 ? [
            {
                id: "ai",
                title: "NB AI",
                type: "item",
                url: "/ems/ai",
                icon: icons["IconSparkles"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "mnv",
            title: "M&V",
            type: "item",
            url: "/ems/mnv",
            icon: icons["IconGitCompare"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/ems/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),

        {
            id: "report_gen",
            title: "Reports",
            type: "item",
            url: "/ems/report_gen",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "kpi",
            title: "Kpi",
            type: "item",
            url: "/ems/kpi",
            icon: icons["IconKey"],
            breadcrumbs: false,
        },
        {
            id: "power",
            title: "Power Failure Log",
            type: "item",
            url: "/ems/power_log",
            icon: icons["IconPower"],
            breadcrumbs: false,
        },
        {
            id: "ghg",
            title: "GHG",
            type: "item",
            url: "/ems/ghg",
            icon: icons["IconCalculator"],
            breadcrumbs: false,
        },
        // {
        //     id: "ghg",
        //     title: "",
        //     type: "item",
        //     icon: icons["IconLineDashed"],
        //     breadcrumbs: false,
        // },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/ems/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/ems/support",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "ems_dashboard",
        type: "group",
        children,
    };
};

export const useDgDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/dg/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/dg/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/dg/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/dg/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/dg/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/dg/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "dg_dashboard",
        type: "group",
        children,
    };
};

export const useBmsDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/bms/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/bms/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/bms/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/bms/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/bms/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/bms/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "bms_dashboard",
        type: "group",
        children,
    };
};

export const useTempDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/temp/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/temp/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/temp/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/temp/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/temp/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/temp/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "temp_dashboard",
        type: "group",
        children,
    };
};

export const usePumpDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/pump/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/pump/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/pump/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/pump/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "ai",
            title: "AI Insights",
            type: "item",
            url: "/pump/ai_insights",
            icon: icons["IconFileReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/pump/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/pump/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "pump_dashboard",
        type: "group",
        children,
    };
};

export const useIndoorDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/indoor/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/indoor/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/indoor/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/indoor/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/indoor/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "indoor_dashboard",
        type: "group",
        children,
    };
};

export const useOutdoorDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/outdoor/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/outdoor/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/outdoor/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/outdoor/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/outdoor/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "outdoor_dashboard",
        type: "group",
        children,
    };
};

export const useFmsDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/fms/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/fms/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/fms/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "log",
            title: "Log",
            type: "item",
            url: "/fms/log",
            icon: icons["IconReceipt"],
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/fms/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "fms_dashboard",
        type: "group",
        children,
    };
};

export const useSolarDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/solar/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "details",
            title: "Details ",
            type: "item",
            url: "/solar/details",
            icon: icons["IconDetails"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/solar/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/solar/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
            {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/solar/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/solar/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "solar_dashboard",
        type: "group",
        children,
    };
};


export const useHVCDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/hvc/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/hvc/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/hvc/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/hvc/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/hvc/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/hvc/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "hvc_dashboard",
        type: "group",
        children,
    };
};

export const useVIBDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/vib/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/vib/analysis",
            icon: icons["IconDeviceAnalytics"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/vib/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/vib/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "ai",
            title: "AI Insights",
            type: "item",
            url: "/vib/ai_insights",
            icon: icons["IconFileReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/vib/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/vib/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "vib_dashboard",
        type: "group",
        children,
    };
};

export const useNBSDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/nbs/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/nbs/alarm",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "metering",
            title: "Metering",
            type: "item",
            url: "/nbs/metering",
            icon: icons["IconLink"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/nbs/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/nbs/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "nbs_dashboard",
        type: "group",
        children,
    };
};

export const useTransDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/trans/home",
            icon: icons["IconDashboard"],
            breadcrumbs: false,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/trans/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/trans/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/trans/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/trans/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/trans/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "trans_dashboard",
        type: "group",
        children,
    };
};

export const useWmsDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/wms/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/wms/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/wms/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/wms/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "kpi",
            title: "Kpi",
            type: "item",
            url: "/wms/kpi",
            icon: icons["IconKey"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/wms/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/wms/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
        // {
        //   id: "alarms_list",
        //   title: "List of Alarms",
        //   type: "item",
        //   url: "/wms/alarms_list",
        //   icon: icons["IconMailbox"],
        //   breadcrumbs: false,
        // },
    ];

    return {
        id: "wms_dashboard",
        type: "group",
        children,
    };
};

export const useAGRDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/agr/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/agr/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/agr/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "agr_dashboard",
        type: "group",
        children,
    };
};

export const useGASDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/gas/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/gas/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/gas/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/gas/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/gas/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/gas/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "gas_dashboard",
        type: "group",
        children,
    };
};

export const useSTEAMDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/steam/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/steam/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/steam/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/steam/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/steam/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/steam/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "steam_dashboard",
        type: "group",
        children,
    };
};

export const useAIRDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();

    const prevCountRef = useRef(notificationCount);
    const audioRef = useRef(null);

    // Initialize audio once
    useEffect(() => {
        audioRef.current = new Audio(alertSound);
        audioRef.current.preload = "auto";
    }, []);

    useEffect(() => {
        if (notificationCount > prevCountRef.current) {
            if (audioRef.current) {
                audioRef.current.currentTime = 0; // reset
                audioRef.current.play().catch((err) => {
                    console.log("Audio play blocked:", err);
                });
            }
        }

        prevCountRef.current = notificationCount;
    }, [notificationCount]);
    
    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/air/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/air/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/air/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/air/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "power",
            title: "Fault Logs",
            type: "item",
            url: "/air/power_log",
            icon: icons["IconPower"],
            breadcrumbs: false,
        },
        {
            id: "backup",
            title: "Retrieve",
            type: "item",
            url: "/air/backup_log",
            icon: icons["IconPower"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/air/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/air/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "air_dashboard",
        type: "group",
        children,
    };
};

export const useBoilerDashboard = () => {
    const account = useSelector((state) => state.account);
    const notificationCount = useSelector((state) => state.notification.count);
    const theme = useTheme();
    useStartNotificationPolling();
 
    const children = [
        {
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/boiler/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        },
        {
            id: "analysis",
            title: "Analysis",
            type: "item",
            url: "/boiler/analysis",
            icon: icons["IconActivity"],
            breadcrumbs: false,
        },
        ...(account.user?.alert_access ? [
            {
                id: "alarms",
                title: "Set Alerts",
                type: "item",
                url: "/boiler/alarms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            }
        ] : []),
        {
            id: "report",
            title: "Reports",
            type: "item",
            url: "/boiler/report",
            icon: icons["IconReport"],
            breadcrumbs: false,
        },
        {
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/boiler/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        },
        {
            id: "support",
            title: "Support",
            type: "item",
            url: "/boiler/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ];

    return {
        id: "boiler_dashboard",
        type: "group",
        children,
    };
};

    export const useFLMSDashboard = () => {
        const account = useSelector((state) => state.account);
        const notificationCount = useSelector((state) => state.notification.count);
        const theme = useTheme();
        useStartNotificationPolling();

        const children = [];

        // Common for all accounts
        children.push({
            id: "home",
            title: "Dashboard",
            type: "item",
            url: "/flms/home",
            icon: icons["IconDashboard"],
            breadcrumbs: true,
        });

        if (account?.flms) {
            children.push(
                {
                    id: "statistics",
                    title: "Statistics",
                    type: "item",
                    url: "/flms/statistics",
                    icon: icons["IconDeviceDesktopAnalytics"],
                    breadcrumbs: false,
                },
                {
                    id: "drivers",
                    title: "Drivers",
                    type: "item",
                    url: "/flms/drivers",
                    icon: icons["IconUsers"],
                    breadcrumbs: false,
                }
            );
        }

        if (account?.flms_own) {
            children.push({
                id: "stats",
                title: "Statistics",
                type: "item",
                url: "/flms/stats",
                icon: icons["IconUsers"],
                breadcrumbs: false,
            });
        }

         if (account.user?.alert_access) {
             children.push({
                 id: "alarms",
                 title: "Set Alerts",
                 type: "item",
                 url: "/flms/vehicleAlert",
                 icon: icons["IconBellPlus"],
                 breadcrumbs: false,
             });
         }

        // children.push({
        //     id: "report",
        //     title: "Reports",
        //     type: "item",
        //     url: "/flms/vehicleReport",
        //     icon: icons["IconReport"],
        //     breadcrumbs: false,
        // });

        children.push({
            id: "allalert",
            title: "Alert List",
            type: "item",
            url: "/flms/all/alert",
            icon: () => (
                <Badge badgeContent={notificationCount} color="error" max={99}>
                    <icons.IconBellRinging style={{ color: theme.palette.secondary.main }} />
                </Badge>
            ),
            breadcrumbs: false,
        });

        // Always shown
        children.push({
            id: "support",
            title: "Support",
            type: "item",
            url: "/flms/help",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        });


        return {
            id: "flms_dashboard",
            type: "group",
            children,
        };
    };

const NBAuditIcon = () => (
    <img src="https://esa.nbsense.in/assets/assets/logo/nbaudit_logo_transparent.png" alt="NBAudit" style={{width: 26, height: 26}}/>
);

export const useSuperAdminDashboard = () => {
    const account = useSelector((state) => state.account);

    // Define the base children array
    let children = [];

    // If user._id is 174, only show these specific sections
    if (account.user?._id === 174) {
        children = [
            {
                id: "home",
                title: "User",
                type: "item",
                url: "/superAdmin/user",
                icon: icons["IconUser"],
                breadcrumbs: false,
            },
            {
                id: "nbaudit",
                title: "NBAudit",
                type: "item",
                url: "/superAdmin/nbaudit",
                icon: <NBAuditIcon />,
                breadcrumbs: false,
            },
            {
                id: "client",
                title: "Client View",
                type: "item",
                url: "/superAdmin/client",
                icon: icons["IconDetails"],
                breadcrumbs: false,
            },
            {
                id: "help",
                title: "Support",
                type: "item",
                url: "/superAdmin/help",
                icon: icons["IconHelp"],
                breadcrumbs: false,
            },
        ];
    } else {
        // If user is not 174, show the other sections as per default
        children = [
            {
                id: "home",
                title: "User",
                type: "item",
                url: "/superAdmin/user",
                icon: icons["IconUser"],
                breadcrumbs: false,
            },
            {
                id: "device",
                title: "Gateway",
                type: "item",
                url: "/superAdmin/device",
                icon: icons["IconDashboard"],
                breadcrumbs: false,
            },
            {
                id: "imei",
                title: "Imei",
                type: "item",
                url: "/superAdmin/imei",
                icon: icons["IconDevices"],
                breadcrumbs: false,
            },
            {
                id: "meter",
                title: "Meter",
                type: "item",
                url: "/superAdmin/meter",
                icon: icons["IconRouter"],
                breadcrumbs: false,
            },
            {
                id: "wms",
                title: "Water Config",
                type: "item",
                url: "/superAdmin/wms",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            },
            {
                id: "dg",
                title: "Diesel Config",
                type: "item",
                url: "/superAdmin/dg",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            },
            {
                id: "bms",
                title: "Bms Config",
                type: "item",
                url: "/superAdmin/bms",
                icon: icons["IconBatteryAutomotive"],
                breadcrumbs: false,
            },
            {
                id: "temp",
                title: "Temp Config",
                type: "item",
                url: "/superAdmin/temp",
                icon: icons["IconTemperaturePlus"],
                breadcrumbs: false,
            },
            {
                id: "hvac",
                title: "Hvac Config",
                type: "item",
                url: "/superAdmin/hvac",
                icon: icons["IconSettingsAutomation"],
                breadcrumbs: false,
            },
            {
                id: "hooter",
                title: "Hooter Config",
                type: "item",
                url: "/superAdmin/hooter",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            },
            {
                id: "flms",
                title: "Fuel Sensor Config",
                type: "item",
                url: "/superAdmin/flms",
                icon: icons["IconFilter"],
                breadcrumbs: false,
            },
            {
                id: "access",
                title: "Meter Access",
                type: "item",
                url: "/superAdmin/access",
                icon: icons["IconPlug"],
                breadcrumbs: false,
            },
            {
                id: "site",
                title: "Site Status",
                type: "item",
                url: "/superAdmin/site",
                icon: icons["IconRoute"],
                breadcrumbs: false,
            },
            {
                id: "client",
                title: "Client View",
                type: "item",
                url: "/superAdmin/client",
                icon: icons["IconDetails"],
                breadcrumbs: false,
            },
            {
                id: "view",
                title: "View Status",
                type: "item",
                url: "/superAdmin/view",
                icon: icons["IconActivity"],
                breadcrumbs: false,
            },
            {
                id: "help",
                title: "Support",
                type: "item",
                url: "/superAdmin/help",
                icon: icons["IconHelp"],
                breadcrumbs: false,
            },
        ];
    }

    return {
        id: "superAdmin_dashboard",
        type: "group",
        children,
    };
};

export const useAdminDashboard = () => {
        const account = useSelector((state) => state.account);

        // Define the base children array
        const children = [
            {
                id: "home",
                title: "User",
                type: "item",
                url: "/admin/user",
                icon: icons["IconUser"],
                breadcrumbs: false,
            },
            {
                id: "meter",
                title: "Meter",
                type: "item",
                url: "/admin/meter",
                icon: icons["IconBellPlus"],
                breadcrumbs: false,
            },
            {
                id: "client",
                title: "Client View",
                type: "item",
                url: "/admin/client",
                icon: icons["IconDetails"],
                breadcrumbs: false,
            },
            {
                id: "help",
                title: "Support",
                type: "item",
                url: "/superAdmin/help",
                icon: icons["IconHelp"],
                breadcrumbs: false,
            },
        ];

        // NBAudit section only is visible to boss
        if ((account.user ? account.user._id : 0) === 174) {
            children.push(
                {
                    id: "site",
                    title: "Site Status",
                    type: "item",
                    url: "/admin/site",
                    icon: icons["IconRoute"],
                    breadcrumbs: false,
                },
                {
                    id: "nbaudit",
                    title: "NBAudit",
                    type: "item",
                    url: "/admin/nbaudit",
                    icon: <NBAuditIcon/>,
                    breadcrumbs: false,
                },
                {
                    id: "help",
                    title: "Support",
                    type: "item",
                    url: "/admin/help",
                    icon: icons["IconHelp"],
                    breadcrumbs: false,
                },
            )
        }

        return {
            id: "admin_dashboard",
            type: "group",
            children,
        };
    };


export const support_dashboard = {
    id: "support_dashboard",
    type: "group",
    children: [
        {
            id: "home",
            title: "Support",
            type: "item",
            url: "/supportAdmin/home",
            icon: icons["IconHelp"],
            breadcrumbs: false,
        },
    ],
};


